import { Link } from '../wrappers/ReactRouterDom';

import global from './GlobalStyle.module.css';
import { getConfig } from '../config/RuntimeConfig';

const PageNotFound = () => {

  return (
    <div className={global.CenterText}>
      <img src={`${getConfig().VITE_CDN_URL}/Usas404.jpg`} alt="Page not found" />
      <p className="CenterText">
        <Link to="/">Return to Home </Link>
      </p>
    </div>
  );
};

export default PageNotFound;